{
  "auth": {
    "agree": "I agree to",
    "createAccount": "Create account",
    "createNewAccount": "Create New Account",
    "email": "Email",
    "login": "Login",
    "password": "Password",
    "recover_password": "Recover password",
    "sign_up": "Sign Up",
    "keep_logged_in": "Keep me logged in",
    "termsOfUse": "Terms of Use.",
    "reset_password": "Reset password"
  },
  "404": {
    "title": "This page’s gone fishing.",
    "text": "If you feel that it’s not right, please send us a message at ",
    "back_button": "Back to dashboard"
  },
  "listPage": {
    "refresh": "Refresh"
  },
  "typography": {
    "primary": "Primary text styles",
    "secondary": "Secondary text styles"
  },
  "dashboard": {
    "versions": "Versions",
    "setupRemoteConnections": "Setup Remote Connections",
    "currentVisitors": "Current Visitors",
    "navigationLayout": "navigation layout",
    "topBarButton": "Top Bar",
    "sideBarButton": "Side Bar"
  },
  "language": {
    "brazilian_portuguese": "Português",
    "english": "English",
    "spanish": "Spanish",
    "simplified_chinese": "Simplified Chinese",
    "persian": "Persian"
  },
  "menu": {
    "auth": "Auth",
    "buttons": "Buttons",
    "timelines": "Timelines",
    "dashboard": "Dashboard",
    "users": "Users",
    "usersList": "User List",
    "usersAdmins": "Admin Management",
    "games": "Games",
    "tags": "Game Tags",
    "posts": "Posts",
    "finance": "Finance",
    "wallets": "Wallets",
    "transactions": "Transactions",
    "tokens": "Tokens",
    "promotions": "Promotions",
    "auditEvents": "Operational Audit",
    "billing": "Billing",
    "login": "Login",
    "preferences": "Account preferences",
    "payments": "Payments",
    "settings": "Application settings",
    "pricing-plans": "Pricing plans",
    "payment-methods": "Payment methods",
    "signup": "Signup",
    "recover-password": "Recover password",
    "recover-password-email": "Recover password email",
    "404": "404",
    "faq": "FAQ",
    "projects": "Projects"
  },
  "messages": {
    "all": "See all messages",
    "new": "New messages from {name}",
    "mark_as_read": "Mark As Read"
  },
  "navbar": {
    "messageUs": "Web development inquiries:",
    "repository": "GitHub Repo"
  },
  "notifications": {
    "all": "See all notifications",
    "less": "See less notifications",
    "mark_as_read": "Mark as read",
    "sentMessage": "sent you a message",
    "uploadedZip": "uploaded a new Zip file with {type}",
    "startedTopic": "started a new topic"
  },
  "user": {
    "language": "Change language",
    "logout": "Logout",
    "profile": "Profile",
    "settings": "Settings",
    "billing": "Billing",
    "faq": "FAQ",
    "helpAndSupport": "Help & support",
    "projects": "Projects",
    "account": "Account",
    "explore": "Explore"
  },
  "treeView": {
    "basic": "Basic",
    "icons": "Icons",
    "selectable": "Selectable",
    "editable": "Editable",
    "advanced": "Advanced"
  },
  "chat": {
    "title": "Chat",
    "sendButton": "Send"
  },
  "spacingPlayground": {
    "value": "Value",
    "margin": "Margin",
    "padding": "Padding"
  },
  "spacing": {
    "title": "Spacing"
  },
  "cards": {
    "cards": "Cards",
    "fixed": "Fixed",
    "floating": "Floating",
    "contentText": "The unique stripes of zebras make them one of the animals most familiar to people.",
    "contentTextLong": "The unique stripes of zebras make them one of the animals most familiar to people. They occur in a variety of habitats, such as grasslands, savannas, woodlands, thorny scrublands, mountains, and coastal hills. Various anthropogenic factors have had a severe impact on zebra populations, in particular hunting for skins and habitat destruction. Grévy's zebra and the mountain zebra are endangered. While plains zebras are much more plentiful, one subspecies, the quagga.",
    "rowHeight": "Row height",
    "title": {
      "default": "Default",
      "withControls": "With controls",
      "customHeader": "Custom header",
      "withoutHeader": "Without header",
      "withImage": "With Image",
      "withTitleOnImage": "With title on image",
      "withCustomTitleOnImage": "With custom title on image",
      "withStripe": "With stripe",
      "withBackground": "With background"
    },
    "button": {
      "main": "Main",
      "cancel": "Cancel",
      "showMore": "Show More",
      "readMore": "Show More"
    },
    "link": {
      "edit": "Edit",
      "setAsDefault": "Set as default",
      "delete": "Delete",
      "traveling": "Traveling",
      "france": "France",
      "review": "Review",
      "feedback": "Leave feedback",
      "readFull": "Read full article",
      "secondaryAction": "Secondary action",
      "action1": "Action 1",
      "action2": "Action 2"
    }
  },
  "colors": {
    "themeColors": "Theme Colors",
    "extraColors": "Extra Colors",
    "gradients": {
      "basic": {
        "title": "Button Gradients"
      },
      "hovered": {
        "title": "Hovered Button Gradients",
        "text": "Lighten 15% applied to an original style (gradient or flat color) for hover state."
      },
      "pressed": {
        "title": "Pressed Button Gradients",
        "text": "Darken 15% applied to an original style (gradient or flat color) for pressed state."
      }
    }
  },
  "tabs": {
    "alignment": "Tabs alignment",
    "overflow": "Tabs overflow",
    "hidden": "Tabs with hidden slider",
    "grow": "Tabs grow"
  },
  "helpAndSupport": "Help & support",
  "aboutVuesticAdmin": "About Vuestic Admin",
  "supportAndConsulting": "Support & Consulting",
  "search": {
    "placeholder": "Search..."
  },
  "users": {
    "title": "User Management",
    "searchPlaceholder": "Search by nickname or email",
    "empty": "No users found",
    "columns": {
      "nickname": "User",
      "email": "Email",
      "role": "Role",
      "status": "Status",
      "mainToken": "Main token",
      "rewardToken": "Reward token",
      "promoToken": "Promo token",
      "mainTokenShort": "Main",
      "rewardTokenShort": "Reward",
      "promoTokenShort": "Promo",
      "createdAt": "Registered",
      "actions": "Actions"
    },
    "role": {
      "admin": "Admin",
      "developer": "Developer",
      "player": "Player"
    },
    "status": {
      "active": "Active",
      "inactive": "Inactive",
      "banned": "Banned"
    },
    "actions": {
      "edit": "Edit user",
      "more": "More actions",
      "sheetTitle": "User actions",
      "sheetSection": "Actions",
      "dangerZone": "Danger zone",
      "deleteSelfDisabled": "You cannot delete your own account",
      "changeStatus": "Change status",
      "adjustTokens": "Adjust tokens",
      "delete": "Delete",
      "ban": "Confirm ban",
      "refresh": "Refresh"
    },
    "form": {
      "editTitle": "Edit user",
      "nickname": "Nickname",
      "email": "Email",
      "role": "Role",
      "status": "Status",
      "avatarReadonly": "Avatar is read-only in this release",
      "save": "Save"
    },
    "pagination": {
      "total": "{total} results",
      "perPage": "Per page"
    },
    "toast": {
      "updateSuccess": "{nickname} has been updated",
      "deleteSuccess": "{nickname} has been deleted",
      "roleChangeWarning": "Role changes require the user to sign in again"
    },
    "confirm": {
      "deleteTitle": "Delete user",
      "deleteMessage": "Delete {nickname}? This is a soft delete and the user will no longer be able to sign in.",
      "banTitle": "Ban user",
      "banMessage": "Ban {nickname}? The user will no longer be able to sign in.",
      "unsavedChanges": "You have unsaved changes. Close anyway?"
    },
    "tokens": {
      "modalTitle": "Adjust tokens",
      "reason": "Adjustment reason",
      "reasonRequired": "Please enter an adjustment reason",
      "amountRequired": "Enter a non-zero amount for at least one token type",
      "modeLabel": "Adjustment mode",
      "mode": {
        "delta": "Delta adjustment",
        "target": "Target balance"
      },
      "modeHint": "Delta mode: enter change amounts. Target mode: enter desired balances (balance only, frozen unchanged).",
      "currentBalances": "Current balances",
      "balance": "Balance",
      "frozen": "Frozen",
      "available": "Available",
      "loading": "Loading…",
      "submit": "Submit adjustment",
      "submitFailed": "Adjustment failed",
      "success": "Adjustment submitted, voucher #{adjustmentId}",
      "disabled": "Token wallet is disabled",
      "loadError": "Failed to load token balances"
    }
  },
  "usersAdmins": {
    "title": "Admin Management",
    "searchPlaceholder": "Search by nickname or email",
    "tabs": {
      "admins": "Current Admins",
      "players": "Players to Promote"
    },
    "actions": {
      "promote": "Promote to Admin",
      "demote": "Demote to Player"
    },
    "confirm": {
      "promoteTitle": "Promote User",
      "promoteMessage": "Promote {nickname} to admin?",
      "demoteTitle": "Demote User",
      "demoteMessage": "Demote {nickname} to player? The role change requires a new sign-in."
    },
    "toast": {
      "roleChanged": "{nickname} role updated to {role}"
    }
  },
  "tags": {
    "title": "Game Tags",
    "searchPlaceholder": "Search by code or name",
    "loading": "Loading…",
    "empty": "No tags found",
    "columns": {
      "code": "Code",
      "type": "Type",
      "name": "Name"
    },
    "type": {
      "all": "All types",
      "genre": "Genre",
      "category": "Category",
      "custom": "Custom"
    },
    "filters": {
      "type": "Tag type"
    },
    "actions": {
      "create": "New tag",
      "edit": "Edit tag",
      "delete": "Delete",
      "refresh": "Refresh"
    },
    "yaml": {
      "export": "Export YAML",
      "import": "Import YAML",
      "template": "Download template",
      "exportSuccess": "Tags exported as YAML",
      "exportFailed": "Export failed",
      "templateSuccess": "Template downloaded",
      "templateFailed": "Failed to download template",
      "parseFailed": "Failed to parse YAML",
      "importTitle": "Import tags",
      "importHint": "Matches by code + tag_type: updates existing tags or creates new ones.",
      "importSummary": "Ready to import {count} tag(s)",
      "confirmTitle": "Confirm import",
      "importSuccess": "Import complete: {created} created, {updated} updated",
      "importPartial": "Partial import: {created} created, {updated} updated, {failed} failed",
      "importFailed": "Import failed",
      "fileSelected": "Selected file"
    },
    "form": {
      "createTitle": "Create tag",
      "editTitle": "Edit tag",
      "code": "Code",
      "codePlaceholder": "e.g. action",
      "type": "Type",
      "name": "Name",
      "namePlaceholder": "Display name",
      "save": "Save"
    },
    "pagination": {
      "total": "{total} results",
      "perPage": "Per page"
    },
    "toast": {
      "createSuccess": "Tag created",
      "updateSuccess": "Tag updated",
      "deleteSuccess": "{name} deleted",
      "deleteInUse": "Cannot delete: {count} game(s) still use this tag"
    },
    "confirm": {
      "deleteTitle": "Delete tag",
      "deleteMessage": "Delete {name}? This cannot be undone."
    }
  },
  "games": {
    "title": "Game Management",
    "searchPlaceholder": "Search by title",
    "empty": "No games found",
    "view": {
      "table": "Table View",
      "card": "Card View"
    },
    "filters": {
      "status": "Status",
      "locale": "Locale"
    },
    "columns": {
      "cover": "Cover",
      "title": "Title",
      "status": "Status",
      "price": "Price",
      "platforms": "Platforms",
      "tags": "Tags",
      "releaseDate": "Release Date"
    },
    "status": {
      "draft": "Draft",
      "review": "In Review",
      "published": "Published",
      "rejected": "Rejected",
      "delisted": "Delisted"
    },
    "price": {
      "free": "Free",
      "comingSoon": "Coming Soon"
    },
    "platform": {
      "windows": "Windows",
      "mac": "Mac",
      "linux": "Linux"
    },
    "pagination": {
      "total": "{total} results",
      "perPage": "Per page"
    },
    "actions": {
      "refresh": "Refresh",
      "create": "Create Game",
      "steamImport": "Steam Import",
      "editTags": "Edit Tags",
      "publish": "Publish",
      "edit": "Edit",
      "cancel": "Cancel",
      "submit": "Create Game"
    },
    "bulk": {
      "select": "Select",
      "selectAllDraft": "Select all drafts on this page",
      "selectedCount": "Selected {selected}/{total}",
      "publishSelected": "Bulk Publish",
      "deleteSelected": "Bulk Delete",
      "confirmTitle": "Confirm Bulk Delete",
      "confirmMessage": "Delete {count} selected draft games? This action cannot be undone.",
      "confirmPublishTitle": "Confirm Bulk Publish",
      "confirmPublishMessage": "Publish {count} selected draft games?",
      "toast": {
        "published": "Published {count} game(s)",
        "publishFailed": "Failed to publish {count} game(s)",
        "deleted": "Deleted {count} game(s)",
        "failed": "Failed to delete {count} game(s)"
      }
    },
    "editTags": {
      "title": "Edit Game Tags",
      "subtitle": "Adjust tags for \"{title}\".",
      "selectedCount": "{count} tags selected",
      "openPicker": "Choose Tags",
      "searchPlaceholder": "Search by tag name or code",
      "noResults": "No tags to display",
      "save": "Save Tags",
      "backToEdit": "Back to Edit",
      "toast": {
        "success": "Tags saved",
        "failed": "Failed to save tags"
      }
    },
    "import": {
      "title": "Steam JSON Import",
      "subtitle": "Upload or paste Steam appdetails JSON, preview the mapping, then create a game draft.",
      "locale": "Import locale",
      "upload": "Upload JSON file",
      "json": "JSON content",
      "placeholder": "Paste the Steam appdetails JSON here",
      "preview": "Preview mapping",
      "import": "Import as draft",
      "reset": "Clear",
      "emptyPreview": "Upload or paste Steam JSON first, then preview the mapping.",
      "fileSelected": "Selected file: {name}",
      "note": "This imports core fields, translations, companies, and supported languages. Screenshots, trailers, and tags can be filled in later from the detail page.",
      "payload": "Request to be submitted",
      "summary": {
        "title": "Import summary",
        "subtitle": "Check whether the preview looks correct.",
        "externalAppId": "Steam AppID",
        "translationLocale": "Translation locale",
        "companies": "Companies",
        "languages": "Supported languages",
        "screenshots": "Screenshots",
        "trailers": "Trailers",
        "tags": "Tags",
        "matchedTags": "Matched tags",
        "unmatchedTags": "Unmatched tags"
      },
      "tags": {
        "title": "Tag mapping",
        "rule": "Matching rule: code first, then name. Unmatched tags are warnings only.",
        "matched": "Matched",
        "unmatched": "Unmatched",
        "empty": "No mappable tags were found in this JSON."
      },
      "errors": {
        "previewFailed": "Preview failed",
        "importFailed": "Import failed",
        "fileReadFailed": "Failed to read the file",
        "tagsLoadFailed": "Failed to load tag list. Auto mapping was skipped."
      },
      "toast": {
        "success": "Game draft created"
      }
    },
    "detail": {
      "title": "Game Detail",
      "yes": "Yes",
      "no": "No",
      "tabs": {
        "overview": "Overview",
        "content": "Content",
        "storeMedia": "Store Media",
        "libraryMedia": "Library Media",
        "pricing": "Pricing",
        "technical": "Technical",
        "audit": "Audit"
      },
      "actions": {
        "viewDetail": "View details for {title}",
        "viewFull": "View full details",
        "close": "Close",
        "backToList": "Back to list"
      },
      "meta": {
        "id": "ID #{id}",
        "locale": "Locale: {locale}",
        "developerId": "Developer ID"
      },
      "sections": {
        "developers": "Developers",
        "publishers": "Publishers",
        "links": "Links"
      },
      "requirements": {
        "minimum": "Minimum",
        "recommended": "Recommended"
      },
      "media": {
        "unnamedTrailer": "Trailer",
        "openTrailer": "Open trailer in new tab"
      },
      "audit": {
        "title": "Review actions",
        "history": "Audit history",
        "actionLabel": "Action",
        "reasonLabel": "Reason",
        "reasonPlaceholder": "Enter review notes or rejection reason",
        "reasonRequired": "Reason is required for reject or request changes",
        "submit": "Submit review",
        "success": "Review submitted successfully",
        "failed": "Failed to submit review",
        "empty": "No audit logs yet",
        "actions": {
          "approve": "Approve",
          "reject": "Reject",
          "request_changes": "Request changes"
        }
      },
      "library": {
        "save": "Save library media",
        "saveSuccess": "Library media saved",
        "saveFailed": "Failed to save library media",
        "readOnlyHint": "Read-only in current status; editable when draft or rejected",
        "notUploaded": "Not uploaded"
      }
    },
    "create": {
      "title": "Create Game",
      "editTitle": "Edit Game",
      "subtitle": "Fill in storefront content, media, and extra metadata step by step.",
      "editSubtitle": "Update storefront content, media, and extra metadata.",
      "steps": {
        "content": "Localized Content",
        "pricing": "Pricing & Platforms",
        "images": "Store Images",
        "assets": "Screenshots & Trailers",
        "details": "Additional Details",
        "review": "Review & Submit"
      },
      "sections": {
        "requirements": "System Requirements",
        "screenshots": "Screenshots",
        "trailers": "Trailers",
        "storeImages": "Store Images",
        "libraryAssets": "Library Assets",
        "icons": "Icons",
        "companies": "Developers / Publishers",
        "supportedLanguages": "Supported Languages",
        "tags": "Tags",
        "summary": "Summary"
      },
      "fields": {
        "title": "Game Title",
        "shortDescription": "Short Description",
        "aboutDescription": "About the Game",
        "detailedDescription": "Detailed Description",
        "pcRequirementsMin": "Windows Minimum Requirements",
        "pcRequirementsRec": "Windows Recommended Requirements",
        "macRequirementsMin": "Mac Minimum Requirements",
        "macRequirementsRec": "Mac Recommended Requirements",
        "linuxRequirementsMin": "Linux Minimum Requirements",
        "linuxRequirementsRec": "Linux Recommended Requirements",
        "isFree": "Free to Play",
        "currency": "Currency",
        "basePriceCents": "Base Price (cents)",
        "originalPriceCents": "Original Price (cents)",
        "comingSoon": "Coming Soon",
        "releaseDate": "Release Date",
        "requiredAge": "Required Age",
        "platformWindows": "Windows",
        "platformMac": "Mac",
        "platformLinux": "Linux",
        "headerImage": "Header Image",
        "mainCapsuleImage": "Main Capsule Image",
        "capsuleImage": "Small Capsule Image",
        "verticalCapsuleImage": "Vertical Capsule Image",
        "capsuleImageV5": "Capsule V5 Image",
        "backgroundImage": "Background Image",
        "backgroundRawImage": "Raw Background Image",
        "libraryCapsuleImage": "Library Capsule Image",
        "libraryHeroImage": "Library Hero Image",
        "libraryLogoImage": "Library Logo Image",
        "libraryHeaderImage": "Library Header Image",
        "iconImage": "Game Icon",
        "appIconImage": "App Icon",
        "earlyAccess": "Early Access",
        "url": "URL",
        "thumbnailUrl": "Thumbnail URL",
        "trailerTitle": "Trailer Title",
        "isHighlight": "Highlight Trailer",
        "externalAppId": "External App ID",
        "externalSource": "External Source",
        "website": "Website",
        "controllerSupport": "Controller Support",
        "supportUrl": "Support URL",
        "supportEmail": "Support Email",
        "metacriticScore": "Metacritic Score",
        "metacriticUrl": "Metacritic URL",
        "recommendationsTotal": "Recommendations Total",
        "achievementsTotal": "Achievements Total",
        "companyName": "Company Name",
        "companyRole": "Company Role",
        "languageCode": "Language Code",
        "hasFullAudio": "Full Audio",
        "tags": "Tags"
      },
      "filters": {
        "tagType": "Tag Type"
      },
      "tagType": {
        "all": "All",
        "genre": "Genre",
        "category": "Category",
        "custom": "Custom"
      },
      "placeholders": {
        "title": "Enter game title",
        "description": "Enter content",
        "url": "https://example.com/asset.jpg",
        "thumbnailUrl": "https://example.com/thumb.jpg",
        "website": "https://example.com",
        "email": "support [at] example.com"
      },
      "buttons": {
        "next": "Next",
        "back": "Back",
        "addScreenshot": "Add Screenshot",
        "addTrailer": "Add Trailer",
        "addCompany": "Add Company",
        "addLanguage": "Add Language",
        "remove": "Remove",
        "upload": "Upload file",
        "uploadFromUrl": "Upload from URL",
        "finish": "Create Game",
        "save": "Save"
      },
      "messages": {
        "updated": "Game saved",
        "forbidden": "You cannot edit this game or its status does not allow editing",
        "loadFailed": "Failed to load game details"
      },
      "summary": {
        "draftStatus": "The game will be created in draft status",
        "screenshots": "Screenshots",
        "trailers": "Trailers",
        "platforms": "Platforms",
        "price": "Price",
        "yes": "Yes",
        "no": "No",
        "readinessChecklist": "Storefront readiness checklist",
        "readinessHint": "Complete all required materials before submitting for review."
      },
      "validation": {
        "primaryTitleRequired": "The zh-CN title is required",
        "atLeastOnePlatform": "Select at least one platform",
        "headerImageRequired": "Header image is required",
        "capsuleImageRequired": "Small capsule image is required",
        "mainCapsuleImageRequired": "Main capsule image is required",
        "verticalCapsuleImageRequired": "Vertical capsule image is required",
        "libraryCapsuleImageRequired": "Library capsule image is required",
        "libraryHeroImageRequired": "Library hero image is required",
        "libraryLogoImageRequired": "Library logo image is required",
        "libraryHeaderImageRequired": "Library header image is required",
        "iconImageRequired": "Game icon is required",
        "appIconImageRequired": "App icon is required",
        "fiveScreenshotsRequired": "At least 5 screenshots are required",
        "oneTrailerRequired": "At least 1 trailer is required",
        "urlRequired": "URL is required",
        "companyNameRequired": "Company name is required",
        "supportedLanguageRequired": "Language code is required"
      },
      "tooltips": {
        "title": "The zh-CN title is required. Use the translate control to fill the other 14 locales.",
        "shortDescription": "A short one-line pitch used in cards and summary views.",
        "aboutDescription": "Main storefront body copy for gameplay, features, and world building.",
        "detailedDescription": "Long-form details and selling points.",
        "requirements": "System requirement fields support localized input. Empty locales are omitted from payload.",
        "headerImage": "Header Capsule. Recommended 920x430 PNG/JPG for the top store header and recommendations.",
        "mainCapsuleImage": "Main Capsule. Recommended 1232x706 PNG/JPG for homepage carousel.",
        "capsuleImage": "Small Capsule. Recommended 462x174 PNG/JPG for list and search placements.",
        "verticalCapsuleImage": "Vertical Capsule. Recommended 748x896 PNG/JPG for vertical promo slots.",
        "capsuleImageV5": "Compact capsule derivative, roughly shown at 184x69. Optional.",
        "backgroundImage": "Store background image. Recommended 1438x810 PNG/JPG. Optional.",
        "backgroundRawImage": "Raw background before processing. Optional.",
        "libraryCapsuleImage": "Library Capsule. Recommended 600x900 PNG/JPG for library grid cover.",
        "libraryHeroImage": "Library Hero. Recommended 3840x1240 PNG/JPG. No text on image.",
        "libraryLogoImage": "Library Logo. Transparent PNG, max width 1280px.",
        "libraryHeaderImage": "Library Header. Recommended 920x430 PNG/JPG for library list header.",
        "iconImage": "Game icon. Recommended 256x256 PNG.",
        "appIconImage": "App icon. Recommended 184x184 PNG.",
        "earlyAccess": "Mark as Early Access release option.",
        "screenshots": "At least 5 gameplay screenshots, 1920x1080, 16:9.",
        "trailer": "At least 1 trailer. Recommended 1920x1080, H.264 + AAC.",
        "trailerTitle": "Trailer title is localized and saved into asset translations.",
        "currency": "If empty, the backend defaults to USD.",
        "basePriceCents": "Price is stored in cents. Example: 1999 = 19.99.",
        "originalPriceCents": "Original pre-discount price, also in cents.",
        "platforms": "Choose at least one supported platform.",
        "releaseDate": "For coming soon titles, use the expected release date.",
        "requiredAge": "Defaults to 0 for unrestricted content.",
        "externalSource": "Optional steam/native source marker.",
        "controllerSupport": "Supported values: none / partial / full. Defaults to none.",
        "companies": "Once a company row is added, both name and role are required.",
        "supportedLanguages": "Once a language row is added, language code is required. Full audio is optional."
      }
    }
  },
  "auditEvents": {
    "title": "Operational Audit",
    "empty": "No audit events found",
    "labels": {
      "anonymous": "Anonymous"
    },
    "hints": {
      "hotData": "By default only the last 90 days are returned. Pick a start date to query older records.",
      "browseSampling": "Browse events are ~10% sampled and are not a complete access log.",
      "compact": "Last 90 days by default · Browse events ~10% sampled"
    },
    "filters": {
      "category": "Category",
      "allCategories": "All categories",
      "action": "Action",
      "actionPlaceholder": "Action, e.g. order.paid",
      "actionPlaceholderOrder": "Action, e.g. order.paid",
      "actionPlaceholderToken": "Action, e.g. token.freeze",
      "actorId": "Actor UUID",
      "actorIdPlaceholder": "Actor UUID",
      "targetType": "Target type",
      "targetTypePlaceholder": "Target type, e.g. order",
      "targetId": "Target ID",
      "targetIdPlaceholder": "Target ID",
      "fromDate": "From date",
      "toDate": "To date",
      "more": "More filters"
    },
    "columns": {
      "createdAt": "Time",
      "event": "Event",
      "actor": "Actor",
      "target": "Target",
      "change": "Change",
      "summary": "Summary"
    },
    "fields": {
      "id": "ID",
      "category": "Category",
      "action": "Action",
      "actorId": "Actor ID",
      "actorRole": "Actor role",
      "targetType": "Target type",
      "targetId": "Target ID",
      "prevValue": "Previous value",
      "newValue": "New value",
      "metadata": "Metadata",
      "ipAddress": "IP address",
      "requestId": "Request ID",
      "userAgent": "User-Agent",
      "createdAt": "Created at"
    },
    "actions": {
      "search": "Search",
      "reset": "Reset",
      "refresh": "Refresh",
      "token_credit": "Token credit",
      "token_freeze": "Token freeze",
      "token_unfreeze_and_debit": "Unfreeze and debit",
      "order_paid": "Order paid",
      "order_refunded": "Order refunded",
      "library_grant": "Library grant",
      "library_revoke": "Library revoke",
      "wallet_offset": "Wallet offset",
      "admin_token_grant": "Admin token grant",
      "admin_token_adjust": "Admin token adjust",
      "admin_token_freeze": "Admin token freeze",
      "admin_order_refund": "Admin order refund",
      "admin_user_role_change": "User role change",
      "admin_user_status_change": "User status change",
      "auth_signup": "User signup",
      "auth_jwt_rejected": "JWT rejected",
      "sensitive_profile_update": "Profile update",
      "access_unauthorized": "Unauthorized access",
      "access_forbidden": "Forbidden access",
      "access_invalid_internal_key": "Invalid internal key",
      "browse_game_search": "Game search",
      "browse_game_detail": "Game detail browse"
    },
    "categories": {
      "wallet": "Wallet",
      "token": "Token",
      "order": "Order",
      "library": "Library",
      "auth": "Auth",
      "sensitive": "Sensitive",
      "admin": "Admin",
      "access": "Access",
      "browse": "Browse"
    },
    "drawer": {
      "title": "Audit event detail",
      "close": "Close"
    },
    "pagination": {
      "total": "{total} events total",
      "perPage": "Per page"
    }
  },
  "buttonSelect": {
    "dark": "Dark",
    "light": "Light"
  },
  "vuestic": {
    "search": "Search",
    "noOptions": "Items not found",
    "ok": "OK",
    "cancel": "Cancel",
    "uploadFile": "Upload file",
    "undo": "Undo",
    "dropzone": "Drop files here to upload",
    "fileDeleted": "File deleted",
    "closeAlert": "close alert",
    "backToTop": "back to top",
    "toggleDropdown": "toggle dropdown",
    "carousel": "carousel",
    "goPreviousSlide": "go previous slide",
    "goNextSlide": "go next slide",
    "goSlide": "go slide {index}",
    "slideOf": "slide {index} of {length}",
    "close": "close",
    "openColorPicker": "open color picker",
    "colorSelection": "color selection",
    "colorName": "color {color}",
    "decreaseCounter": "decrease counter",
    "increaseCounter": "increase counter",
    "selectAllRows": "select all rows",
    "sortColumnBy": "sort column by {name}",
    "selectRowByIndex": "select row {index}",
    "resetDate": "reset date",
    "nextPeriod": "next period",
    "switchView": "switch view",
    "previousPeriod": "previous period",
    "removeFile": "remove file",
    "reset": "reset",
    "pagination": "pagination",
    "goToTheFirstPage": "go to the first page",
    "goToPreviousPage": "go to the previous page",
    "goToSpecificPage": "go to the {page} page",
    "goToSpecificPageInput": "enter the page number to go",
    "goNextPage": "go next page",
    "goLastPage": "go last page",
    "currentRating": "current rating {value} of {max}",
    "voteRating": "vote rating {value} of {max}",
    "optionsFilter": "options filter",
    "splitPanels": "split panels",
    "movePaginationLeft": "move pagination left",
    "movePaginationRight": "move pagination right",
    "resetTime": "reset time",
    "closeToast": "close toast",
    "selectedOption": "Selected option",
    "noSelectedOption": "Option is not selected",
    "breadcrumbs": "breadcrumbs",
    "counterValue": "counter value",
    "selectedDate": "selected date",
    "selectedTime": "selected time",
    "progressState": "progress state",
    "color": "color",
    "next": "Next",
    "back": "Previous",
    "finish": "Finish",
    "step": "step",
    "progress": "progress",
    "loading": "Loading",
    "sliderValue": "Current slider value is {value}",
    "switch": "Switch",
    "inputField": "Input field",
    "fileTypeIncorrect": "File type is incorrect",
    "select": "Select an option"
  }
}
